import type { SliceStateFromReducer } from 'shared/types';

import type { userSlice } from './user.slice';

export type TUserState = SliceStateFromReducer<typeof userSlice>;

export const userSelector = (state: TUserState) => (state.user.isLoggedIn ? state.user : null);
export const accountSelector = (state: TUserState) => (state.user.isLoggedIn ? state.user.account : null);
export const userIdSelector = (state: TUserState) => (state.user.isLoggedIn ? state.user.account?.sub || null : null);
export const isLoggedSelector = (state: TUserState) => state.user.isLoggedIn;

export const userHasEsiaSelector = (state: TUserState) => !!state.user.account?.isHasEsia;
export const userEsiaStartStepSelector = (state: TUserState) => state.user.esiaStep;
export const userEsiaIsErrorSelector = (state: TUserState) => state.user.esiaErrorCount > 2;
export const userDeviceIdSelector = (state: TUserState) => state.user.deviceId;
